const ContentTypes = {
    CARDS: {
        name: 'Cartões',
        build: () => ({
            id: `novo-card-${Math.round(Math.random() * Number.MAX_SAFE_INTEGER)}`,
            title: '',
            description: '',
            picture: null,
        }),
    },
    MINICARDS: {
        name: 'Mini cartões',
        build: () => ({
            id: `novo-minicard-${Math.round(Math.random() * Number.MAX_SAFE_INTEGER)}`,
            title: '',
            description: '',
            picture: null,
            items: [],
        }),
    },
    ITEMS: {
        name: 'Lista de itens',
        build: () => ({
            title: '',
            items: [],
        }),
    },
};

export default ContentTypes;



// WEBPACK FOOTER //
// ./src/utils/content-types.js